export default __webpack_public_path__ + "static/media/A12.025305ba.png";